import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import ProductPicker from '../../../components/common/ProductPicker.js'
import { useRouter } from 'next/router'
import Head from 'next/head'
// import SEO from '../../components/common/SEO.js'
import { EmptyLayout } from '../../../layouts'

function IFrameComponent(props) {
  console.log(props)
  const router = useRouter()
  return (
      <div>
        <ProductPicker
          key='product-picker'
          handlelogin={()=>{}}
          logged_in={false}
          router={router}/>
      </div>
  )
}

IFrameComponent.getLayout = function getLayout(page) {
  return (
    <EmptyLayout>
      {page}
    </EmptyLayout>
  )
}

IFrameComponent.getInitialProps = async (props) => {
  const { slug } = props.query
  return { slug: slug }
}

export default IFrameComponent
